import { action } from 'src/store/actions';

export const FETCH_NO_PAYOUT_RATIONALES = 'FETCH_NO_PAYOUT_RATIONALES';
export const REQUEST_NO_PAYOUT_RATIONALES = 'REQUEST_NO_PAYOUT_RATIONALES';
export const SUCCESS_NO_PAYOUT_RATIONALES = 'SUCCESS_NO_PAYOUT_RATIONALES';
export const FAILURE_NO_PAYOUT_RATIONALES = 'FAILURE_NO_PAYOUT_RATIONALES';

export const fetchNoPayoutRationales = () => action(FETCH_NO_PAYOUT_RATIONALES);
export const requestNoPayoutRationales = () => action(REQUEST_NO_PAYOUT_RATIONALES);
export const requestNoPayoutRationalesSuccess = (response: any) => action(SUCCESS_NO_PAYOUT_RATIONALES, { response });
export const requestNoPayoutRationalesFailure = (error: any) => action(FAILURE_NO_PAYOUT_RATIONALES, { error });
